import React, { useEffect, useState } from 'react';
import Header from "../../components/Header/Header";
import PromoItem from "../../components/PromoItem/PromoItem";
import { useDispatch, useSelector } from "react-redux";
import { getPromoSagaAction, sortSagaAction } from "../../redux/sagaActions";
import PromoHeader from "../../components/PagesHeaders/PromoHeader/PromoHeader";
import PromoForm from "../../components/PromoForm/PromoForm";
import { ReactSortable } from "react-sortablejs";

const Promo = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const promo = useSelector(state => state.promo);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...promo];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'promo',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    // Получение списка акций
    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(getPromoSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <PromoHeader/> }/>
            <PromoForm/>
            <div className="page">
                <div className="promo__items">
                    <ReactSortable
                        list={ list }
                        setList={ setList }
                        handle={ '.control--move' }
                        onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
                    >
                        {
                            promo.map(elem => {
                                return <PromoItem data={ elem } key={ elem.id }/>
                            })
                        }
                    </ReactSortable>
                </div>
            </div>
        </>
    );
};

export default Promo;